import isEmpty from "lodash/isEmpty";
import { FilterRangeSlider } from "PFApp/components/filters/filter_range_slider";
import { IntegerValue, NumberFilter } from "PFTypes";
import { useEffect, useState } from "react";

type IntegerItemProps = {
  label: string;
  filter: NumberFilter;
  handleChange: (value: IntegerValue | null) => void;
  disabled?: boolean;
  searchId?: number;
};

export const IntegerItem = ({ label, filter, handleChange, disabled, searchId }: IntegerItemProps) => {
  const { value: originalValue } = filter;
  const rangeValue = originalValue as IntegerValue | undefined;

  const [statistics, setStatistics] = useState(filter.statistics || { min: 0, max: 0 });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const { query } = filter;
    if (query && !filter.statistics) {
      setLoading(true);
      query({ value: null, term: null })
        .then((resp) => {
          setStatistics(
            resp.statistics || {
              min: Math.max(rangeValue?.gte || 0, (filter.defaultValue as IntegerValue)?.gte),
              max: Math.max(rangeValue?.lte || 0, (filter.defaultValue as IntegerValue)?.lte)
            }
          );
        })
        .finally(() => setLoading(false));
    }
  }, [searchId]);

  const defaultRange = filter.defaultValue as IntegerValue | undefined;
  const showClearLink = !isEmpty(rangeValue) && !filter.required;
  const showRestoreLink =
    defaultRange && (defaultRange.gte !== rangeValue?.gte || defaultRange.lte !== rangeValue?.lte);

  return (
    <FilterRangeSlider
      onChange={handleChange}
      onClear={showClearLink ? () => handleChange(null) : undefined}
      onRestore={showRestoreLink ? () => handleChange(defaultRange) : undefined}
      value={{ gte: rangeValue?.gte || statistics.min, lte: rangeValue?.lte || statistics.max }}
      disabled={disabled}
      label={label}
      required={filter.required}
      loading={loading}
      {...statistics}
    />
  );
};
